import { LoadingIcon } from '@assets/icons';
import { InfiniteScrollTableComponents } from '@components/infiniteScroll';
import { Group } from '@components/layout';
import {
  GetVolumeDataQuery,
  GetVolumeDetailsVolumeDataQuery,
  VolumeData,
} from '@generated/graphql';
import { Box, useTheme } from '@mui/material';
import { Dispatch, SetStateAction } from 'react';
import { TableVirtuoso } from 'react-virtuoso';
import { ListViewHeader } from './ListViewHeader';
import { ListViewItem } from './ListViewItem';

type ListViewProps = {
  directory: string[];
  loading: boolean;
  volumeData: GetVolumeDataQuery['getVolumeData']['keys'];
  volumeId: string;
  volumeMetadata: GetVolumeDetailsVolumeDataQuery['getVolumes'][0];
  fetchMore: VoidFunction;
  refetchVolumes: () => Promise<unknown>;
  setDirectory: Dispatch<SetStateAction<string[]>>;
};

export const ListView = (props: ListViewProps) => {
  const { volumeData, loading, fetchMore } = props;
  const { palette } = useTheme();

  const tableRow = (_, volume: VolumeData) => <ListViewItem volume={volume} {...props} />;
  if (loading) {
    return (
      <Group height="100%" alignItems="center" justifyContent="center">
        <LoadingIcon size={16} />
      </Group>
    );
  }
  return (
    <Box p={4} sx={{ backgroundColor: palette.background.paper, width: '100%', height: '100%' }}>
      <TableVirtuoso
        data={volumeData}
        endReached={fetchMore}
        components={InfiniteScrollTableComponents}
        fixedHeaderContent={ListViewHeader}
        itemContent={tableRow}
        increaseViewportBy={400}
      />
    </Box>
  );
};
